module.exports = __webpack_public_path__ + "img/chipmunk.ffa60e1c.png";